import React from "react";
import { useNavigate } from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useDataContext, useLayoutContext } from "context";
import useStyles from "./styles";

type SidebarSubmenuHeaderProps = {
  title: string | undefined;
  subTitle: string | undefined;
  icon: React.ReactNode;
  link: string;
};

export const SidebarSubmenuHeader: React.FC<SidebarSubmenuHeaderProps> = ({
  title,
  subTitle,
  icon,
  link,
}) => {
  const { classes, cx } = useStyles();
  const dataContext = useDataContext();
  const layoutContext = useLayoutContext();
  const navigate = useNavigate();

  return (
    <ListItem
      className={cx(
        classes.listItem,
        layoutContext.menuOpen ? null : classes.listItemClosed,
      )}
      onClick={() => navigate(link)}
    >
      <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
      <ListItemText
        classes={{
          primary: cx(
            classes.listItemText,
            layoutContext.menuOpen ? null : classes.menuClosed,
          ),
        }}
      >
        <div
          className={cx(
            title && !dataContext.isLoadingStateEntities
              ? classes.title
              : classes.titleLoading,
          )}
        >
          {dataContext.isLoadingStateEntities ? "" : title}
        </div>
        <div
          className={cx(
            subTitle && !dataContext.isLoadingStateEntities
              ? classes.subTitle
              : classes.subTitleLoading,
          )}
        >
          {dataContext.isLoadingStateEntities ? "" : subTitle}
        </div>
      </ListItemText>
    </ListItem>
  );
};
